import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 180px;

    h2 {
      margin-top: 20px;
      color: ${theme.colors.black};
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.medium};
      text-align: center;
    }

    ${media.lessThan('small')`
      svg {
        width: 182px;
        height: 42px;
      }

      h2 {
        font-size: ${theme.font.sizes.xsmall};
      }
    `}
  `}
`
